import { RootState } from '../shared/state/root-reducer';

export type ClientWithAiPes = {
  clientId: number;
  hasAiPes?: boolean;
};

/** Resolve client id from selected patient, else selected encounter. */
export function resolveSelectedPatientClientId(state: RootState): number | null {
  const patientClientId = state.patientContext?.selectedPatient?.clientId;
  if (patientClientId != null && patientClientId !== '' && Number(patientClientId) > 0) {
    return Number(patientClientId);
  }
  const encounterClientId = state.patientContext?.selectedEncounter?.clientId;
  return encounterClientId != null && encounterClientId > 0 ? encounterClientId : null;
}

export function shouldShowCallPatientButton(params: {
  isLoadingClients: boolean;
  selectedPatientClientId: number | null;
  allClientsMap: Map<number, ClientWithAiPes> | undefined;
}): boolean {
  const { isLoadingClients, selectedPatientClientId, allClientsMap } = params;
  if (isLoadingClients || !selectedPatientClientId || !allClientsMap) {
    return false;
  }
  const patientClient = allClientsMap.get(selectedPatientClientId);
  return patientClient?.hasAiPes === true;
}
